module.exports = __webpack_public_path__ + "images/emails/i-3-12683aae.gif";